module.exports = __webpack_public_path__ + "media/polearmhit.3f14198b.wav";